import React, { useState, useRef, useEffect } from "react";
import countryJson from "../../../Compoents/countries.json";

const countryArray = Object.entries(countryJson).map(([code, data]) => ({
  code,
  ...data,
}));

const PhoneField = ({
  value,
  onChange,
  placeholder = "Phone Number*",
  defaultCountryCode = "IN",
  onCountryChange,
  disabled = false,
  className = "",
}) => {
  const [phone, setPhone] = useState(value || "");
  const [isOpen, setIsOpen] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState(
    countryArray.find((c) => c.code === defaultCountryCode) || countryArray[0]
  );
  const dropdownRef = useRef(null);

  // Sync internal state if `value` prop changes (controlled mode)
  useEffect(() => {
    if (value !== undefined) setPhone(value);
  }, [value]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handlePhoneChange = (e) => {
    const val = e.target.value;
    setPhone(val);
    onChange?.({ phone: val, country: selectedCountry });
  };

  const handleCountrySelect = (country) => {
    setSelectedCountry(country);
    setIsOpen(false);
    onCountryChange?.(country);
    onChange?.({ phone, country });
  };

  return (
    <div className={`relative ${className}`} ref={dropdownRef}>
      {/* Single Unified Box */}
      <div className="flex items-center rounded-full px-3 py-2 gap-2 mb-3">
        {/* Country Selector */}
        <div
          className={`flex items-center gap-1 shrink-0 bg-blue-50 rounded-full px-8 w-[150px] py-8 ${
            isOpen ? "border border-blue-900" : ""
          } ${
            disabled ? "opacity-50 cursor-not-allowed" : "cursor-pointer"
          }`}
          onClick={() => !disabled && setIsOpen(!isOpen)}
        >
          <img
            src={selectedCountry?.image}
            alt={selectedCountry?.name}
            className="w-10 h-10 rounded-lg"
          />
          <span className="ml-1 text-lg font-medium text-gray-700">
            {selectedCountry?.phone?.[0]}
          </span>
          <span className="absolute left-[120px] text-lg text-gray-500">▼</span>
        </div>

        {/* Divider */}
        <div className="w-px h-6 bg-gray-300" />

        {/* Phone Input */}
        <input
          type="tel"
          value={phone}
          onChange={handlePhoneChange}
          placeholder={placeholder}
          disabled={disabled}
          className={`flex-1 outline-none text-base text-gray-700 placeholder-gray-400 bg-transparent ${
            disabled ? "opacity-50 cursor-not-allowed" : ""
          }`}
        />
      </div>

      {/* Dropdown */}
      {isOpen && (
        <div className="absolute z-50 bg-white border border-gray-300 w-full max-h-64 overflow-y-auto mt-1 rounded-xl shadow-lg">
          {countryArray.map((country) => (
            <div
              key={country.code}
              className="flex items-center gap-3 px-4 py-2 hover:bg-gray-100 cursor-pointer"
              onClick={() => handleCountrySelect(country)}
            >
              <img src={country.image} alt={country.name} className="w-8 h-8" />
              <span className="text-lg">{country.name}</span>
              <span className="ml-auto text-lg text-gray-500">
                {country.phone[0]}
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default PhoneField;